import { Inject, Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfig {

	public webServerUrl: string;
	public identityServerUrl: string;
	public agentServiceUrl: string;
	public authServiceUrl: string;
	public configServiceUrl: string;
	public dataServiceUrl: string;
	public sessionServiceUrl: string;

	constructor(private http: HttpClient) { }

	public load(): void {
		let baseUrl = window.location.origin + '/';

		this.webServerUrl = baseUrl;
		this.identityServerUrl = baseUrl;
		this.agentServiceUrl = baseUrl;
		this.authServiceUrl = baseUrl;
		this.configServiceUrl = baseUrl;
		this.dataServiceUrl = baseUrl;
		this.sessionServiceUrl = baseUrl;
	}

	//public load(): void {
	//	return new Promise((resolve, reject) => {
	//		this.http.get('config/endpoints')
	//			.catch((error: any) => {
	//				console.error('Error reading config/endpoints');
	//				resolve(error);
	//				return Observable.throw(error.json().error || 'Error reading config/endpoints');
	//			})
	//			.subscribe((responseData) => {
	//				this.loadConfig(responseData as AppConfig);
	//				resolve(true);
	//			});
	//	});
	//}

	//private loadConfig(config: AppConfig): void {
	//	this.webServerUrl = config.webServerUrl;
	//	this.identityServerUrl = config.identityServerUrl;
	//	this.agentServiceUrl = config.agentServiceUrl;
	//	this.authServiceUrl = config.authServiceUrl;
	//	this.configServiceUrl = config.configServiceUrl;
	//	this.dataServiceUrl = config.dataServiceUrl;
	//	this.sessionServiceUrl = config.sessionServiceUrl;
	//}
}